import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { ReadXlsxWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('ReadXlsx')
export class ReadXlsxDataNode extends BaseWorkflowNode<ReadXlsxWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.xlsxFileUrl, schemas),
      ...(this.node.sortRequests?.flatMap((sort) =>
        getColumnReferencesFromString(sort.columnName, schemas),
      ) ?? []),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.xlsxFileUrl, schemas),
      ...(this.node.sortRequests?.flatMap((sort) =>
        getTagReferencesFromString(sort.columnName, schemas),
      ) ?? []),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(this.node.xlsxFileUrl, schemas, connectors),
      ...(this.node.sortRequests?.flatMap((sort) =>
        getParamReferencesFromString(sort.columnName, schemas, connectors),
      ) ?? []),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(this.node.xlsxFileUrl, schemas),
      ...(this.node.sortRequests?.flatMap((sort) =>
        getNamedInputReferencesFromString(sort.columnName, schemas),
      ) ?? []),
    ];
  }
}
